<template>
  <div class="avatar-wrapper">
    <a
      ref="avatar"
      class="avatar-box"
      @click="toggleVisible"
    >
      <Avatar
        :is-premium="userInfo.premium"
        :src="userInfo.avatar"
      />
    </a>
    <ClientOnly>
      <ElPopover
        ref="avatarPopoverRef"
        :offset="offset"
        :virtual-ref="avatar"
        :visible="avatarPopoverVisible"
        popper-class="pp-header-bar-avatar-popover"
        virtual-triggering
        width="320px"
      >
        <UserInfoPopover
          :show-user-nav="showUserNav"
          @after-logout="emit('after-logout')"
        />
      </ElPopover>
    </ClientOnly>
    <slot name="userNameAndVipInfo" />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { ref } from '#imports'
import { useUserInfo } from '@/store/userInfo'
import { onClickOutside } from '@vueuse/core'
import { ElPopover } from 'element-plus'
import Avatar from '../drive/Avatar.vue'
import UserInfoPopover from '../drive/UserInfoPopover.vue'

withDefaults(defineProps<{
  offset?: number
  showUserNav?: boolean
  showAccountNav?: boolean
}>(), {
  offset: 20,
})

const userInfo = useUserInfo()
const avatar = ref<HTMLElement>()
const avatarPopoverRef = ref<HTMLElement>()
const avatarPopoverVisible = ref(false)

const toggleVisible = () => {
  if (!userInfo.username) return
  avatarPopoverVisible.value = !avatarPopoverVisible.value
}

onClickOutside(avatarPopoverRef, () => {
  avatarPopoverVisible.value = false
}, { ignore: [avatar] })

// eslint-disable-next-line no-spaced-func
const emit = defineEmits<{
  (e: 'after-logout'): void
}>()
</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

.avatar-wrapper {
  display: flex;
  align-items: center;
}

.avatar-box {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #000;
}

.user-name {
  font-weight: 700;
  margin-left: 8px;
}
</style>
<style lang="less">
.pp-header-bar-avatar-popover {
  overflow: hidden;
  --el-popover-padding: 0 !important;
  --el-popover-border-radius: 16px !important;
}

.logout-cancel-button {
  color: #000 !important;
}
</style>
